import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCalculations({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_CALCULATIONS_REQUEST')

        return axios
            .get(`/calculations/calculations${paginate}${query}`)
            .then(response => {
                commit('GET_CALCULATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CALCULATIONS_FAILURE')
                handleApiError(error, 'Pobranie listy kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculation({ commit }, id) {
        return axios
            .get(`/calculations/calculations/${id}`)
            .then(response => {
                commit('GET_CALCULATION', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationImpositionTaskPriceComponents(context, calculation_pk) {
        return axios
            .get(`/calculations/calculation/${calculation_pk}/calculation-imposition-task-price-components`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie składników cenowych kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationImpositionTask(context, payload) {
        return axios
            .get(`/calculations/calculations/imposition-task/${payload.id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie zadania impozycji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCalculationImpositionTask(context, payload) {
        return axios
            .put(`/calculations/calculations/imposition-task/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zadania impozycji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    copyImpositionParameters(context, payload) {
        return axios
            .post('/calculations/copy-calculation-imposition-parameters', { ...payload })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Kopiowanie parametrów impozycji nie powiodło się.')
            })
    },
    getCalculationImposition(context, payload) {
        return axios
            .get(`/calculations/calculations/imposition/${payload.id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie impozycji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCalculationImposition(context, payload) {
        return axios
            .put(`/calculations/calculations/imposition/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja impozycji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    updateCalculationImpositionTaskPriceComponents(context, payload) {
        return axios
            .put(`/calculations/calculation/${payload.calculation_pk}/calculation-imposition-task-price-components/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja składników cenowych kalkulacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    temporarySaveCalculationData({ commit }, data) {
        commit('TEMPORARY_SAVE_CALCULATION_DATA', data)
    },
    createCalculation({ commit }, payload) {
        return axios
            .post('/calculations/calculations', payload, {
                timeout: 0
            })
            .then(response => {
                commit('GET_CALCULATION', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Utworzenie kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCalculation({ commit }, calculation) {
        return axios
            .put(`/calculations/calculations/${calculation.id}`, calculation, {
                timeout: 0
            })
            .then(response => {
                commit('GET_CALCULATION', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja kalkulacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteCalculation(context, id) {
        return axios
            .delete(`/calculations/calculations/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    copyCalculation(context, payload) {
        return axios
            .post('/calculations/copy-calculation', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Skopiowanie kalkulacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCalculationTraderMargin(context, payload) {
        return axios
            .patch(`/calculations/calculation-trader-margin/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja marży nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getCalculationValidation(context, id) {
        return axios
            .get(`/calculations/calculations/${id}/validation`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie walidacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProducts() {
        return axios
            .get('/calculations/calculation-product-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationsStatuses({ commit }) {
        return axios
            .get('/calculations/dicts/calculation-status')
            .then(response => {
                commit('GET_CALCULATIONS_STATUS_LIST', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductComponents(context, id) {
        return axios
            .get(`/calculations/calculation-product-types/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie komponentów produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationColorTemplates() {
        return axios
            .get('/calculations/dicts/calculation-colour-template')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie słownika wzorów kolorystycznych nie powiodło się.')

                return Promise.reject(error)
            })

    },
    getCalculationPrintColors({ commit }, {
        query = ''
    } = {}) {
        return axios
            .get(`/calculations/dicts/calculation-print-colour${query}`)
            .then(response => {
                commit('GET_CALCULATION_PRINT_COLORS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów kolorów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPackageBoxTypes() {
        return axios
            .get('/package-definitions/dicts/box-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów pakowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPackagesTypes() {
        return axios
            .get('/package-definitions/dicts/package-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów opakowań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    palletQuantityCalculator(context, payload) {
        return axios
            .post('/package-definitions/pallet-quantity-calculator', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Obliczenie ilości palet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printCalculationPriceOffer(context, payload) {
        return axios
            .post('/calculations/calculations/card-print', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie oferty cenowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printCalculationReport(context, payload) {
        return axios
            .post('/calculations/calculations/card-print', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDeliveryMethods(context, {
        query = ''
    } = {}) {
        return axios
            .get(`/deliveries/dicts/delivery-methods${query}`,)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie metod dostawy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    calculateDeliveryCost(context, payload) {
        return axios
            .post('deliveries/calculate-delivery-price', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Obliczenie kosztu dostawy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addCalculationProduct({ commit }, payload) {
        commit('ADD_CALCULATION_PRODUCT', payload)
    },
    copyCalculationProduct({ commit }, payload) {
        commit('COPY_CALCULATION_PRODUCT', payload)
    },
    updateCalculationProduct({ commit }, product) {
        commit('UPDATE_CALCULATION_PRODUCT', product)
    },
    removeCalculationProduct({ commit }, id) {
        commit('REMOVE_CALCULATION_PRODUCT', id)
    },
    createNewImpositions({ commit }, data) {
        commit('CREATE_NEW_IMPOSITIONS', data)
    },
    addImposition({ commit }, data) {
        commit('ADD_IMPOSITION', data)
    },
    removeImposition({ commit }, id) {
        commit('REMOVE_IMPOSITION', id)
    },
    updateImposition({ commit }, data) {
        commit('UPDATE_IMPOSITION', data)
    },
    setProductComponent({ commit }, data) {
        commit('SET_PRODUCT_COMPONENT', data)
    },
    setCalculationsFilters({ commit }, filters) {
        commit('SET_CALCULATIONS_FILTERS', filters)
    },
    clearCalculationsFilters({ commit }, filters) {
        commit('SET_CALCULATIONS_FILTERS', filters)
    },
}
